import api from "@/app/_module/services/api";
import { getApiUrl } from "@/app/_module/services/config";
import { handleApiCall } from "@/app/_module/utils/apiResponseHandler";

export interface StateStats {
  state: string;
  count: number;
  totalPremium: number;
  /** Sold & Approved only. totalPremium is gross and includes Underwriting. */
  issuedPremium?: number;
  topCarrier: string;
}

export const getPolicyStatsByState = async (): Promise<StateStats[]> => {
  return handleApiCall(async () => {
    const response = await api.get<{ statusCode: number; data: StateStats[] }>({
      url: getApiUrl("policies/stats/by-state"),
      auth: true,
    });
    return (response as any)?.data?.data || (response as any)?.data || [];
  });
};
